export const HEATMAP_GET_ALL_DATA = "HEATMAP_GET_ALL_DATA";
export const HEATMAP_UPDATE_USER = "HEATMAP_UPDATE_USER";
export const HEATMAP_UPDATE_USER_COMMENT = "HEATMAP_UPDATE_USER_COMMENT";
export const HEATMAP_UPDATE_TEAM = "HEATMAP_UPDATE_TEAM";
export const HEATMAP_UPDATE_TEAM_COMMENT = "HEATMAP_UPDATE_TEAM_COMMENT";
export const HEATMAP_GET_PREV_DATA = "HEATMAP_GET_PREV_DATA";
export const HEATMAP_GET_NEXT_DATA = "HEATMAP_GET_NEXT_DATA";
export const HEATMAP_UPDATE_DEPARTMENT = "HEATMAP_UPDATE_DEPARTMENT";
export const HEATMAP_UPDATE_DEPARTMENT_COMMENT = "HEATMAP_UPDATE_DEPARTMENT_COMMENT";